import React from 'react';

import { messages } from './messages';
import { TextSection } from '../../../tab-section/text-section/text-section';

export const ImportedAsShipped = () => {
  return (
    <TextSection
      ariaLabelMessageDescriptor={messages.importedAsShippedSectionAriaLabel}
      contentMessageDescriptor={messages.importedAsShippedContent}
      headerMessageDescriptor={messages.importedAsShippedHeader}
    />
  );
};
